<template>
  <div class="d-flex flex-column h-100 ding-text">
    <Top :commonResponse="commonResponseData"></Top>
    <div class="container text-center h-100">
      <div class="row justify-content-md-center h-100">
        <div class="col-10">
            <main class="px-3" style="display: flex;align-items: center;justify-content: center;">
              <div class="page-container">
                <!-- 第一行文字：逐字渐显+跳动效果 -->
                <div class="first-line" ref="firstLineRef">
                  {{comfInfo.text}}
                </div>
                <br/>
                <!-- 第二行文字：固定文字淡入 + 8位数字滚轮 -->
                <div class="second-line">
                  <span class="static-text" ref="staticTextLeftRef">欢迎(*^▽^*)，第</span>
                  <!-- 8位数字滚轮容器 -->
                  <span class="number-container">
                    <div class="roller" v-for="(digit, index) in digits" :key="index" ref="rollerRefs">
                      <div class="roller-inner" ref="rollerInnerRefs">
                        <div class="roller-item" :style="{color:getColor()}">0</div>
                        <div class="roller-item" :style="{color:getColor()}">1</div>
                        <div class="roller-item" :style="{color:getColor()}">2</div>
                        <div class="roller-item" :style="{color:getColor()}">3</div>
                        <div class="roller-item" :style="{color:getColor()}">4</div>
                        <div class="roller-item" :style="{color:getColor()}">5</div>
                        <div class="roller-item" :style="{color:getColor()}">6</div>
                        <div class="roller-item" :style="{color:getColor()}">7</div>
                        <div class="roller-item" :style="{color:getColor()}">8</div>
                        <div class="roller-item" :style="{color:getColor()}">9</div>
                      </div>
                    </div>
                  </span>
                  <span class="static-text" ref="staticTextRightRef">次访问的访客</span>
                </div>
                <p class="lead" id="revealText"></p>
                <p class="lead">
                  <a href="/updateLog" class="btn btn-lg btn-light fw-bold border-black bg-white">更新日志</a>
                </p>                
              </div>
            </main>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-end">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col">
            <footer class="mt-auto text-black-50">
              <p>
                <span class="fw-bold btn text-secondary" @click="pointer()">反馈与建议</span>&ensp;|&ensp;<span class="text-black fw-bold">164office</span> All Rights Reserved. 备案号: 鄂ICP备2022008452号
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="live2dModel" style="cursor: pointer;">
    <canvas ref="liveCanvas" @click="action()"></canvas>
  </div>  
</template>


<script>
import { Popover } from "bootstrap";
import Page from '@/components/Page.vue';
import Top from "@/components/Top.vue";
import { saveVisitLog,getTotalVisits } from "../api/visitLog";
import { getHomeNotice } from "../api/systemConfig";

// 在需要使用 Live2D 的组件中引入
import vueLive2d from 'vue-live2d'
import * as PIXI from 'pixi.js'
import { Live2DModel } from "pixi-live2d-display";  // .model.json
// import { Live2DModel } from "pixi-live2d-display/cubism4";  // .model3.json
import { indices } from "@/api/qWeather"

window.PIXI = PIXI; // 为了pixi-live2d-display内部调用
let app; // 为了存储pixi实例
let model; // 为了存储live2d实例

export default {
  name: "home",
  components: {
    Top,
    Page,
    vueLive2d  // 注册 Vue-live2d 组件
  },
  data() {
    return {
      page: {
        size: 10,
        currentPage: 1, // 偏移量,数据库从0开始
        totalPage: 0,
      },
      commonResponseData: { // Modal 弹窗数据
        success: true,
        msg: '',
      },
      visitLogInfo: {},
      publicKey: '',
      privateKey: '',
      ip: '',
      intervalId: null, // 用于存储 setInterval 的 ID

      lock: false,  // 锁,防止重复点击触发 aya 语音
      audioContext: {},
      dataArray: {},
      timeFlag: 0,  // 用于限制频繁点击 live2d
      models: [ {name:'aya',x:200,y:90},{name:'yifu',x:200,y:120},{name:'qiansheng',x:200,y:90},{name:'huayin',x:200,y:90},{name:'saya',x:200,y:95} ],
      modelIndex: 0,
      targetNumber: 12345, // 最终目标数字（5位）
      digits: [0, 0, 0, 0, 0], // 拆分后的5位数字数组
      charDelay: 120, // 第一行每个字显示间隔(ms)
      baseOpacity: 0.6, // 第一个字初始透明度
      opacityStep: 0.2, // 每个字透明度差值
      comfInfo: {
        text: '(o゜▽゜)o☆[BINGO!]'
      }  // 舒适度指数
    }
  },
  //需要引入
  beforeUnmount() {
    model?.destroy();
    app?.destroy();
  },
  async mounted() {
    document.title = "ding! office!";
    indices().then(
      response => {
        if(response.data.data.code==200){
          this.comfInfo = response.data.data.daily[0];
          this.$nextTick(() => {
            // 初始化第一行文字动画
            this.initFirstLineAnimation();            
          })

        }
      }
    )
    this.getTotalVisits();  // 获取首页总访问量
    saveVisitLog(Object.assign({key:0}));
    // 首页逐字显示欢迎语
    // this.revealText();  // 方法一
    // this.showText();  // 方法二

    this.modelIndex = Math.floor(Math.random() * 5);
    this.audioContext = new AudioContext();
    app = new PIXI.Application({
      view: this.$refs.liveCanvas,  // ref 组件绑定, liveCanvas 为下文自定义的
      autoStart: true,  // 是否开启自动播放
      resizeTo: window,
      backgroundAlpha: 0,  //透明度
    });
    // 这里是放 live2d 资源的地方, 直接相对路径引用即可
    // model = await Live2DModel.from("../aya/aya.model.json");
    // model =await Live2DModel.from("../aya/aya.model.json", { autoInteract: true });
    // model = await Live2DModel.from("../aya/aya.model.json", { autoInteract: false });  // 注意 .model.json 与 .model3.json 所导入的包不一样
    // model =await  Live2DModel.from("https://cdn.jsdelivr.net/gh/guansss/pixi-live2d-display/test/assets/haru/haru_greeter_t03.model3.json");

    // document.getElementById("aya").addEventListener('pointermove', (event) => model.focus(event.clientX, event.clientY));  // 绑定追踪鼠标事件,仅鼠标在画布内有效
    // document.getElementById("aya").addEventListener('pointerdown', (event) => model.tap(event.clientX, event.clientY));  // 绑定点击事件

    model =await Live2DModel.from('../'+this.models[this.modelIndex].name+'/'+this.models[this.modelIndex].name+'.model.json',{ autoInteract: this.modelIndex!=0 });

    app.stage.addChild(model);

    model.x=this.models[this.modelIndex].x;  // 设置模型在画布中的位置
    model.y=this.models[this.modelIndex].y;  // 设置模型在画布中的位置
    model.scale.set(0.2);  // 调整缩放比例,0.1-0.2整体比较合适
    // this.$refs.liveCanvas.width = "700";  // 画布大小,必须最后设置,否则会被某些原因重置
    // this.$refs.liveCanvas.height = "670";

    if (this.modelIndex!=0) {
      model.motion('act');
      // model.motion('init');
    }

  },
  updated() {  // 更新之后.场景:获取更新真实DOM之后
    /**
     * 尝试一下放在 updated() 和 mounted() 中分别有什么区别
     */
    var popoverTriggerList = Array.prototype.slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new Popover(popoverTriggerEl)
    });
  },
  methods: {
    commonPageChange(event) { // 通用分页
      this.page = event;
    },
    revealText() {
      if (!this.intervalId) {
        this.intervalId = setInterval(this.customFunction, 100); // 每秒执行一次
      }
    },
    customFunction() {
      const textElement = document.getElementById("revealText");
      var len = textElement.innerHTML==null?"":textElement.innerHTML.length;
      if (len<this.text.length) {
        textElement.innerHTML = textElement.innerHTML+this.text[len];
      }
      else {
        clearInterval(this.intervalId);
      }
    },
    showText() {
      const textElement = document.getElementById("revealText");
      var len = textElement.innerHTML.length;  // 获取以显示的文本长度
      if (len<this.text.length) {  // 比较总长度
        textElement.innerHTML = textElement.innerHTML + this.text[len];
        setTimeout(() => {
          this.showText();
        }, 50);
      }
    },
    //  动作与对应的语音太难找
    //  而且导入vue后声音嘴型同步失效, 需要额外执行代码更改参数,但似乎动作控制的嘴部优先级更高,因为只有动作执行完毕后才由代码控制嘴型
    //  而且后置动作失效
    //  所以将语音和动作分开执行,但会出现角色讲话无动作表情
    action() {
      // this.$refs.liveCanvas.addEventListener('pointermove', (event) => model.focus(event.clientX, event.clientY));
      // this.$refs.liveCanvas.addEventListener('pointerdown', (event) => model.tap(event.clientX, event.clientY));
      // model.motion("额头");

      if (this.modelIndex==0) {  // 目前仅支持 aya 有交互效果,其他角色仅视线跟随鼠标
        console.log("timeFlag:" + (Date.now() - this.timeFlag) / 1000);
        const num = Math.random();
        console.log("num:"+num);
        if (num > 0.58) {  // 仅触发语音
          if (Date.now() - this.timeFlag > 5 * 1000) {
            this.timeFlag = Date.now();
            console.log("触发语音! lock:" + this.lock);
            if (!this.lock) {
              this.lock = true;
              var audioFile = './aya/sound/' + Math.floor(Math.random() * 13) + '.mp3';
              console.log("audioFile:"+audioFile);
              this.speaking(audioFile);
            }
          }
          else {
            console.log("频繁操作!");
          }
        }
        else {  // 仅触发动作
          if (Date.now() - this.timeFlag > 10 * 1000) {
            this.timeFlag = Date.now();
            console.log("触发动作!");
            model.motion('web'+Math.floor(Math.random() * 13));
            setTimeout(this.initModel, 10000);
          }
          else {
            console.log("频繁操作!");
          }
        }
      }

    },
    initModel() {
      console.log("恢复状态");
      model.motion('init');
    },
    pointer() {
      this.$router.push("/pointer");
    },
    async speaking(audioFile) {
      const response = await fetch(audioFile);
      const audioData = await response.arrayBuffer();
      const audioBuffer = await this.audioContext.decodeAudioData(audioData);
      const source = this.audioContext.createBufferSource();
      const analyser = this.audioContext.createAnalyser();
      source.buffer = audioBuffer;
      analyser.connect(this.audioContext.destination);
      source.connect(analyser);

      var that = this;
      source.onended = function() {
        that.lock = false;
        console.log('Audio playback has ended.   lock:'+that.lock);
      };

      source.start();
      // source.volume = 0;

      const updateMouth = () => {
        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(dataArray);
        const volume = dataArray.reduce((a, b) => a + b) / dataArray.length;
        const mouthOpen = Math.min(1, volume / 100);
        model.internalModel.coreModel.setParamFloat('PARAM_MOUTH_OPEN_Y', mouthOpen);
        if (this.audioContext.state !== 'close') {
          requestAnimationFrame(updateMouth);
        }
      }
      updateMouth();
    },
    /**
     * 第一行文字：逐字渐显+跳动+透明度梯度
     */
    initFirstLineAnimation() {
      const firstLineEl = this.$refs.firstLineRef;
      const originalText = firstLineEl.textContent.trim();
      firstLineEl.innerHTML = "";

      // 拆分每个字为span
      originalText.split("").forEach((char, index) => {
        const span = document.createElement("span");
        span.className = "char";
        span.textContent = char;
        firstLineEl.appendChild(span);

        // 逐字触发动画
        setTimeout(() => {
          // 透明度梯度
          const currentOpacity = Math.max(0, this.baseOpacity - index * this.opacityStep);
          span.style.opacity = currentOpacity;
          span.classList.add("visible");

          // 补全透明度
          setTimeout(() => {
            span.style.opacity = 1;
          }, 300);
        }, index * this.charDelay);
      });
    },

    /**
     * 第二行固定文字淡入
     */
    initStaticTextAnimation() {
      setTimeout(() => {
        this.$refs.staticTextLeftRef.classList.add("visible");
        this.$refs.staticTextRightRef.classList.add("visible");
      }, 500);
    },

    /**
     * 初始化滚轮位置为00000000
     */
    initRollerPosition() {
      const innerElements = this.$refs.rollerInnerRefs;
      innerElements.forEach(inner => {
        // 强制初始位置为0（无过渡）
        inner.style.transform = 'translateY(0)';
        inner.style.transition = 'none';
      });
    },

    /**
     * 启动流畅的数字滚轮动画（从00000000滚动到99999999）
     */
    startSmoothRoller() {
      const innerElements = this.$refs.rollerInnerRefs;
      // 为每个滚轮添加过渡效果，逐位延迟启动
      innerElements.forEach((inner, index) => {
        // 延迟触发滚动（逐位启动，波浪效果）
        setTimeout(() => {
          // 添加平滑弹性过渡
          inner.style.transition = 'transform 2s cubic-bezier(0.2, 0.85, 0.32, 1.2)';
          // 滚动到目标数字位置（9 → -900%）
          inner.style.transform = `translateY(-${this.digits[index] * 100}%)`;
        }, 100 + index * 200); // 每个滚轮延迟100ms+index*200ms启动
      });
    },
    getTotalVisits() {
      getTotalVisits().then(
        response => {
          if(response.data.code==1){
            this.targetNumber = response.data.data.totalVisits
            this.$nextTick(() => {
              // 拆分8位目标数字为数组（确保8位，不足补0）
              this.digits = this.targetNumber.toString().padStart(5, '0').split('').map(Number);
              
              // 初始化第二行固定文字淡入
              this.initStaticTextAnimation();            
              // 初始化滚轮位置为00000000（强制初始显示0）
              this.initRollerPosition();
              setTimeout(() => {
                this.startSmoothRoller();
              }, 800);
            })   
          }
        }
      )
    },
    getColor() {  // 总访客数字颜色
      return ['#FFEEAA','#DDBBFF','#FF88BB','#99DD88','#55DDEE'][Math.floor(Math.random()*5)];
    }
  },
};
</script>

<style>
/* 设置canvas的悬浮样式 */
.live2dModel {
  
    position: fixed;  /* 使用fixed定位使canvas悬浮 */
    right: 0;  /* 必须设值,用于定位画布在页面中的位置 */
    bottom: 0;  /* 必须设值,用于定位画布在页面中的位置 */
    
    width: 700px;
    height: 670px;

    /* 确保canvas在其他内容之上 */
    z-index: 1000;
}

/* 第一行文字样式 */
.first-line {
  font-size: 24px;
  color: #333;
  line-height: 1.6;
  white-space: nowrap;
}

/* 单个文字样式 */
.char {
  display: inline-block;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.5s cubic-bezier(0.17, 0.67, 0.83, 0.67);
}

/* 文字跳动动画 */
.char.visible {
  animation: bounce 0.6s ease forwards;
}

@keyframes bounce {
  0% { opacity: 0; transform: translateY(20px); }
  60% { transform: translateY(-5px); }
  100% { opacity: 1; transform: translateY(0); }
}

/* 第二行文字样式 */
.second-line {
  font-size: 28px;
  color: #2c3e50;
  font-weight: 500;
}

/* 固定文字淡入 */
.static-text {
  opacity: 0;
  transition: opacity 1s ease 0.5s;
}

.static-text.visible {
  opacity: 1;
}

/* 数字容器 */
.number-container {
  display: inline-flex;
  margin: 0 5px;
  align-items: center;
}

/* 单个滚轮样式（核心：3D效果+流畅滚动） */
.roller {
  width: 35px;
  height: 40px;
  overflow: hidden;
  margin: 0 2px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  perspective: 100px; /* 3D透视效果 */
}

/* 滚轮内部容器 */
.roller-inner {
  width: 100%;
  height: 100%;
  transform: translateY(0);
  will-change: transform; /* 性能优化 */
}

/* 滚轮单个数字项 */
.roller-item {
  width: 100%;
  height: 100%;
  line-height: 40px;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  /* color: #ff88bb; */
  box-sizing: border-box;
}
</style>